export const getFilterNamedOptions = ({ options, attributeEffects }: { options: string[]; attributeEffects: any }) => {
  const collectUsedOptions = attributeEffects
    .filter((effect: any) => effect?.criteria === 'named')
    .map((effect: any) => effect?.labelName?.named)
    .filter((el: any) => typeof el === 'string' && el !== '')
  const filteredOptions = options.filter((option: string) => !collectUsedOptions.includes(option))
  return filteredOptions
}
